/**
 * Shared component for general list and forms.
 */
import {ServiceAnswer} from '../../../shared/service-answer';

export class BaseComponent<T = any> {
  public loading: boolean | ServiceAnswer<T> = null;

  protected name: string;

  public getElementId(elementId: string) {
    return this.name + '_' + elementId;
  }
}
